import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { ReactComponent as ChevronLeft } from '../icons/chevron-left-solid.svg';

export default class Header extends Component {
    state = {
        anchorEl: null
    }
    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget })
    }
    handleClose = () => {
        this.setState({ anchorEl: null })
    }
    refreshPage = () => window.location.reload(false)

    render() {
        const { anchorEl } = this.state
        return (
            <>
                <header className="header">
                    <div className="header-items">
                        <img id="logo" src="//www.ecan.govt.nz/_resources/themes/ecan/images/logo.png" title="Environment Canterbury" alt="Environment Canterbury"></img>
                        {(this.props.goback) ? <div className="backBtn">
                            <ChevronLeft style={{ marginLeft: '-2px' }} className='action-icon' />
                            {(() => (window.location.pathname !== "/") ? <Link to='/'>Back to form</Link> : <a href="/" onClick={this.refreshPage}>Back to form</a> )()}
                        </div> :
                            <nav className="navbar">
                                <Button aria-controls="simple-menu" aria-haspopup="true" onClick={this.handleClick}>Menu</Button>
                                <Menu
                                    id="simple-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={this.handleClose}
                                >
                                    <MenuItem onClick={this.handleClose}><Link to='/map'>Heat map</Link></MenuItem>
                                    <MenuItem onClick={this.handleClose}><Link to='/help'>Help</Link></MenuItem>
                                </Menu>
                            </nav>}
                    </div>
                </header>
            </>
        )
    }
}